import React from 'react';
import {Button, Form} from "react-bootstrap";

const PasswordInformationStep = ({activeStep, setActiveStep}) => {
    return (
        <>
            <div className="row justify-content-center">
                <div className="col-xl-10">
                    <div className="card custom-card">
                        <div className="card-body">
                            <h5 className="text-center">Password Information</h5>

                            <div className="row">
                                <div className="col-lg-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Ticket Master:</Form.Label>
                                        <Form.Control type="text" placeholder="Password123" />
                                    </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Gmail:</Form.Label>
                                        <Form.Control type="text" placeholder="Password123!" />
                                    </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label>AXS:</Form.Label>
                                        <Form.Control type="text" placeholder="Password1" />
                                    </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Seatgeek:</Form.Label>
                                        <Form.Control type="text" placeholder="Password@123" />
                                    </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label>MLB Ballpark:</Form.Label>
                                        <Form.Control type="text" placeholder="Password13" />
                                    </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Paciolan:</Form.Label>
                                        <Form.Control type="text" placeholder="Password123" />
                                    </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Other:</Form.Label>
                                        <Form.Control type="text" placeholder="Password" />
                                    </Form.Group>
                                </div>
                                
                                <div className="col-lg-12 mt-5">
                                    <div className="row justify-content-between">
                                        <div className="col-lg-3 d-flex mb-3">
                                            <Button
                                                variant="primary"
                                                className="text-white mt-auto w-100"
                                                onClick={() => setActiveStep(pre => pre - 1)}
                                            >
                                                Previous
                                            </Button>
                                        </div>
                                        <div className="col-lg-3 d-flex mb-3">
                                            <Button
                                                variant="primary"
                                                className="text-white mt-auto w-100"
                                                onClick={() => setActiveStep(0)}
                                            >
                                                Done
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PasswordInformationStep;